import { ArrowOption } from '@ritabygglov/core';
import { Side } from '../../../../types';
import { createRoundedLine } from '../../shapes';

type DimensionArrowProps = {
  start: [number, number];
  end: [number, number];
  showStartMarker?: boolean;
  id: string;
};

const getArrowStyle = (side: Side, option: ArrowOption, arrowStyle: string) => {
  if (option === ArrowOption.slim) {
    const d = side === Side.left ? 'M1,1 L3,3 L1,5' : 'M3,1 L1,3 L3,5';
    return (
      <path
        d={d}
        fill="transparent"
        stroke={arrowStyle}
        strokeWidth={1.5}
        strokeLinejoin="round"
        className="dimension-arrow-marker"
      />
    );
  } else if (option === ArrowOption.thick) {
    const d = side === Side.left ? 'M0,0 V4 L2,2 Z' : 'M2,0 V4 L0,2 Z';
    return <path d={d} fill={arrowStyle} className="dimension-arrow-marker" />;
  } else {
    return <path d="" />;
  }
};

export const DimensionArrow = ({
  start,
  end,
  showStartMarker = false,
  id,
}: DimensionArrowProps) => {
  return (
    <>
      <defs>
        <marker
          id={`${id}-arrow`}
          key={`${id}-arrow`}
          orient="auto"
          markerWidth="4"
          markerHeight="6"
          refX="2.5"
          refY="3"
        >
          {getArrowStyle(Side.left, ArrowOption.slim, '#000')}
        </marker>
        <marker
          id={`${id}-arrow-end`}
          key={`${id}-arrow-end`}
          orient="auto"
          markerWidth="4"
          markerHeight="6"
          refX="1.5"
          refY="3"
        >
          {getArrowStyle(Side.right, ArrowOption.slim, '#000')}
        </marker>
      </defs>
      <path
        key={id}
        id={id}
        d={createRoundedLine([start, end])}
        stroke="#000"
        strokeWidth={0.8}
        fill="transparent"
        markerEnd={`url(#${id}-arrow)`}
        markerStart={showStartMarker ? `url(#${id}-arrow-end)` : undefined}
        className="dimension-arrow-line"
      />
    </>
  );
};
